(function () {
  function initPdpGalleryScrollbar() {
    $('[data-pdp-scrollbar]').each(function () {
      var $scrollbar = $(this);
      var $galleryWrap = $scrollbar.closest('.thumbnail-single-img');
      var $slickElement = $galleryWrap.find('.slider-for').first();
      var $thumb = $scrollbar.find('[data-pdp-thumb]').first();
      var $track = $scrollbar.find('.pdp-gallery-scrollbar-track').first();

      if (!$slickElement.length || !$thumb.length || !$track.length) return;
      if ($scrollbar.data('pdp-scrollbar-ready')) return;

      $scrollbar.data('pdp-scrollbar-ready', true);

      var thumbDragging = false;
      var thumbStartX = 0;
      var thumbStartLeft = 0;
      var lastSlideCount = 0;
      var lastDragIndex = -1;

      function getPoint(e) {
        if (e.type.indexOf('touch') === 0) {
          return (e.originalEvent.touches && e.originalEvent.touches[0]) ||
            (e.originalEvent.changedTouches && e.originalEvent.changedTouches[0]);
        }

        return e;
      }

      function getThumbMetrics(count) {
        var trackWidth = $track[0].clientWidth || $track.width() || 0;
        var minWidth = parseFloat($thumb.css('min-width')) || 0;
        var rawWidth = count > 0 ? trackWidth / count : trackWidth;
        var thumbWidth = Math.min(trackWidth, Math.max(minWidth, rawWidth));

        return {
          thumbWidth: thumbWidth,
          maxLeft: Math.max(0, trackWidth - thumbWidth)
        };
      }

      function setThumbPosition(index, count) {
        var metrics = getThumbMetrics(count);
        var maxIndex = Math.max(1, count - 1);
        var safeIndex = Math.max(0, Math.min(index, count - 1));
        var left = (safeIndex / maxIndex) * metrics.maxLeft;

        $thumb.css({
          width: metrics.thumbWidth + 'px',
          left: left + 'px'
        });
      }

      function updatePdpScrollbar(slick, currentSlide) {
        if (!slick) return;

        var count = slick.slideCount || 0;
        var index = typeof currentSlide === 'number' ? currentSlide : (slick.currentSlide || 0);
        lastSlideCount = count;

        if (count <= 1) {
          $scrollbar.addClass('is-hidden');
          return;
        }

        $scrollbar.removeClass('is-hidden');

        if (thumbDragging) {
          $thumb.css('width', getThumbMetrics(count).thumbWidth + 'px');
          return;
        }

        setThumbPosition(index, count);
      }

      $slickElement.on('init.pdpScrollbar reInit.pdpScrollbar afterChange.pdpScrollbar setPosition.pdpScrollbar', function (event, slick, currentSlide) {
        updatePdpScrollbar(slick, typeof currentSlide === 'number' ? currentSlide : (slick.currentSlide || 0));
      });

      if ($slickElement.hasClass('slick-initialized')) {
        var slick = $slickElement.slick('getSlick');
        updatePdpScrollbar(slick, slick.currentSlide || 0);
      }

      $thumb.on('mousedown.pdpScrollbar touchstart.pdpScrollbar', function (e) {
        var point = getPoint(e);

        if (!point) return;

        e.preventDefault();
        e.stopPropagation();
        thumbDragging = true;
        lastDragIndex = -1;
        thumbStartX = point.clientX;
        thumbStartLeft = $thumb[0].offsetLeft;
        document.body.style.userSelect = 'none';
      });

      $track.on('mousedown.pdpScrollbar touchstart.pdpScrollbar', function (e) {
        var point = getPoint(e);

        if (e.target === $thumb[0] || $(e.target).closest('[data-pdp-thumb]').length) return;
        if (!point || !$slickElement.hasClass('slick-initialized') || lastSlideCount <= 1) return;

        e.preventDefault();

        var rect = $track[0].getBoundingClientRect();
        var metrics = getThumbMetrics(lastSlideCount);
        var nextLeft = Math.max(0, Math.min(point.clientX - rect.left - metrics.thumbWidth / 2, metrics.maxLeft));
        var ratio = metrics.maxLeft > 0 ? nextLeft / metrics.maxLeft : 0;
        var index = Math.round(ratio * (lastSlideCount - 1));

        $slickElement.slick('slickGoTo', index);
      });

      $(window).on('mousemove.pdpScrollbar touchmove.pdpScrollbar', function (e) {
        var point = getPoint(e);

        if (!thumbDragging || !point) return;

        e.preventDefault();

        var metrics = getThumbMetrics(lastSlideCount);
        var nextLeft = Math.max(0, Math.min(thumbStartLeft + (point.clientX - thumbStartX), metrics.maxLeft));
        var ratio = metrics.maxLeft > 0 ? nextLeft / metrics.maxLeft : 0;
        var index = Math.round(ratio * Math.max(0, lastSlideCount - 1));

        $thumb.css('left', nextLeft + 'px');

        if (index !== lastDragIndex && $slickElement.hasClass('slick-initialized')) {
          lastDragIndex = index;
          $slickElement.slick('slickGoTo', index);
        }
      });

      $(window).on('mouseup.pdpScrollbar touchend.pdpScrollbar touchcancel.pdpScrollbar', function () {
        if (!thumbDragging) return;

        thumbDragging = false;
        lastDragIndex = -1;
        document.body.style.userSelect = '';

        if ($slickElement.hasClass('slick-initialized')) {
          var metrics = getThumbMetrics(lastSlideCount);
          var currentThumbLeft = parseFloat($thumb[0].style.left) || 0;
          var ratio = metrics.maxLeft > 0 ? currentThumbLeft / metrics.maxLeft : 0;
          var index = Math.round(ratio * Math.max(0, lastSlideCount - 1));

          $slickElement.slick('slickGoTo', index);
          setThumbPosition(index, $slickElement.slick('getSlick').slideCount || lastSlideCount);
        }
      });
    });
  }

  $(document).ready(initPdpGalleryScrollbar);
  $(document).on('shopify:section:load', initPdpGalleryScrollbar);
})();
